import { useEffect, useState } from "react";
import fr from "./assets/legal-notice.fr.md?raw";
import en from "./assets/legal-notice.en.md?raw";
import { Markdown } from "./Markdown";
import { i18n } from "@thetreep/ui";

export function LegalNotice() {
  const [language, setLanguage] = useState(i18n.language);

  useEffect(() => {
    const onLanguageChanged = (lng: string) => setLanguage(lng);
    i18n.on("languageChanged", onLanguageChanged);
    return () => {
      i18n.off("languageChanged", onLanguageChanged);
    };
  }, []);

  switch (language) {
    case "fr":
      return <Markdown content={fr} />;
    case "en":
      return <Markdown content={en} />;
    default:
      return null;
  }
}
